var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOhJazzWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.32 418.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efe8e2}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0 329h30.09v58.47c0 1.92.64 3 2.77 3h11.31c2.14 0 2.78-1.28 2.78-3.2v-95H13.44l5.34-28.81H78.1V396c0 12.16-7.46 22.19-20.91 22.19h-36.7C8.32 418.19 0 410.51 0 398.34Zm119.08 70-2.78 19.21H85.14l28-154.72h33.08l27.95 154.72H143L140.2 399Zm3.41-24.54h14.3l-7-54.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.54 389.38h29l-5.34 28.81h-65.3l34.78-125.91h-32.19l5.34-28.81h67Zm78.32 0h29l-5.34 28.81h-65.3L284 292.28h-32.2l5.34-28.81h67Zm-10.83-191.06h41.98v44.67h-41.98zm-14.07 46.85V0h-49v95.21h-31.29V0h-49v245.17h50.15v-93.04h28.99v93.04h50.15zM127.44 29.89C127.44 11.18 115.9 0 96.57 0H32C12.66 0 1.12 11.18 1.12 29.89v181.59c0 20.39 11.79 32.09 32.33 32.09h61.66c20.54 0 32.33-11.7 32.33-32.09ZM77.63 198.64H50.68V44.93h26.95ZM274.46 0l5.46 190.52h42.33L328.32 0h-53.86z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOhJazzWhite);
export default __webpack_public_path__ + "static/media/Oh_jazz_white.3cc1a0caf4735b1e517415321a5eb5f7.svg";
export { ForwardRef as ReactComponent };